var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('i',{staticClass:"fa fa-arrows"}),_c('span',[_vm._v(" "+_vm._s(_vm.banner.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }